<app-item [entity]="entity">
    <app-payment-request-reminder-summary [entity]="entity"></app-payment-request-reminder-summary>
</app-item>
